export const ACTIVITY_HISTORY_ANCHOR_ID = "activity-history";

export const ACTIVITY_HISTORY_HASH = `#${ACTIVITY_HISTORY_ANCHOR_ID}`;

export const BALANCE_ACTIVITY_HISTORY_PATH = `/balance${ACTIVITY_HISTORY_HASH}`;

export function scrollToActivityHistory() {
  document.getElementById(ACTIVITY_HISTORY_ANCHOR_ID)?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
}
